// packages/api-client/queries/flaws/index.ts
import { useQuery, } from "@tanstack/react-query";
export const createFlawsQueries = (requests, queryClient) => ({
    useListFlaws: (params, options = {}) => useQuery({
        queryKey: ["flaws", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listFlaws(params);
        },
        ...options,
    }),
    useFindFlaw: (params, options = {}) => useQuery({
        queryKey: ["flaw", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findFlaw(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map